let welfareList = {
    typeList: [
      { text: "全部类型", value: "" },
      { text: "统一生日慰问", value: "1" },
      { text: "自选生日慰问", value: "2" }
    ],
    statueList: [
      { text: "全部状态", value: "" },
      { text: "未开始", value: "0" },
      { text: "进行中", value: "1" },
      { text: "已结束", value: "2" }
    ],
    welfareState: {
      //福利状态
      "0": "未开始",
      "1": "进行中",
      "2": "已结束"
    },
    welFareFree1: {
      //福利类型
      "1": "统一生日慰问",
      "2": "自选生日慰问"
    },
  };
  export default welfareList;
  